import { mapToCompanyInfoList } from 'helpers';
import { IPartner, IPartnerSimpleInfoItem } from '../models';
import { ICompanyDetails } from '../../../models';

export function mapCompanyDetails(
	titles: IPartnerSimpleInfoItem[],
	data?: IPartner,
): ICompanyDetails | undefined {
	if (!data) return;

	const {
		formalName,
		logoUrl,
		shortName,
		contractStartDate,
		contractEndDate,
		website,
		contractUrl,
		surveyCount,
		surveyCountLimit,
	} = data;

	return {
		logoUrl,
		shortName,
		formalName,
		// TODO add adapter mapContractData
		contractData: {
			startDate: contractStartDate,
			endDate: contractEndDate,
			fileKey: contractUrl,
			fileUrl: contractUrl,
		},
		domain: '',
		companyURL: website,
		infoList: mapToCompanyInfoList(
			(data as unknown) as Record<string, number>,
			titles,
		),
		sent: surveyCount,
		allowedLimit: surveyCountLimit,
	};
}
